import { SR_STATUS, SRStatus } from './constants';

export interface ServiceRequestIdRef {
  id: string;
}

export interface BulkStatusPayload {
  serviceRequest: ServiceRequestIdRef[];
  name: SRStatus;
  userId: string;
  propertyId: string;
}

export interface BulkDeclinePayload {
  serviceRequest: ServiceRequestIdRef[];
  name: typeof SR_STATUS.Declined;
  userId: string;
  Reason: string;
  ReasonType: string;
}

export interface GroupPayload {
  GroupName: string | null;
  id: string | null;
  PropertyId: string;
  UserId: string;
  Subject: null;
  Description: null;
  SuiteId: null;
  AssetId: null;
  IssueTypeId: null;
  IssueTypeName: null;
  ServiceRequest: ServiceRequestIdRef[];
}

export const toIdRefs = (ids: string[]): ServiceRequestIdRef[] => {
  return ids.map((id: string) => ({ id }));
};
